import { fetchProvider } from './fetch';
import { InfoForExample, MostSubscribedProducts, ProductInfo } from '../model/product';
import { SiteConfigurationResponse, SiteInfo } from '../model/site';
import { LastEligibleOrderInfo } from '../model/order';
import { SubscriptionInfo } from '../model/subscriptionProducts';

export const CentralHubService = (token: string | undefined) => {
  const fetch = fetchProvider(token, 'autoshipment-central-hub-front', '/loy/api/autoshipment/v1/');

  const getMostSubscribedProducts = async (siteDomain: string, language: string) =>
    (
      await fetch.get<MostSubscribedProducts>(
        `central-hub/most-subscribed?siteDomain=${siteDomain}&language=${language}`,
      )
    ).responseBody;

  const getInfoForExamplesSection = async (siteDomain: string, language: string) =>
    (
      await fetch.get<InfoForExample[]>(
        `central-hub/site-example-article-savings?siteDomain=${siteDomain}&language=${language}`,
      )
    ).responseBody;

  const getSiteInfo = async (siteDomain: string) =>
    (await fetch.get<SiteInfo>(`central-hub/site-info?siteDomain=${siteDomain}`)).responseBody;

  const getLastEligibleOrder = async (siteDomain: string) =>
    (
      await fetch.post<LastEligibleOrderInfo>(`order/last-eligible-order`, {
        siteDomain: siteDomain,
      })
    ).responseBody;

  const getPdpArticleInformation = async (shopIdentifier: string, language: string) =>
    (
      await fetch.get<ProductInfo>(
        `central-hub/pdp-article?shopIdentifier=${shopIdentifier}&language=${language}`,
      )
    ).responseBody;

  const getSiteConfig = async (siteDomain: string) =>
    (await fetch.get<SiteConfigurationResponse>(`site/${siteDomain}`)).responseBody;

  const getSubscriptions = async (siteDomain: string) =>
    (
      await fetch.get<SubscriptionInfo>(
        `central-hub/upcoming-autoshipments?siteDomain=${siteDomain}`,
      )
    ).responseBody;

  return {
    getMostSubscribedProducts,
    getInfoForExamplesSection,
    getSiteInfo,
    getSiteConfig,
    getLastEligibleOrder,
    getPdpArticleInformation,
    getSubscriptions,
  };
};
